'use client'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { useStoreNavigate } from '@/hooks/use-app-navigate'

/**
 * TranslationDetailsNotFound component
 * Displays when a translation is not found
 */
export function TranslationDetailsNotFound() {
	const { t } = useTranslation('languages')
	const { storeRoutes } = useStoreNavigate()

	return (
		<div className="bg-background min-h-screen flex items-center justify-center">
			<Alert variant="destructive" className="max-w-md">
				<AlertCircle className="h-4 w-4" />
				<AlertTitle>{t('notFound')}</AlertTitle>
				<AlertDescription>{t('notFoundDescription')}</AlertDescription>
				<div className="mt-4">
					<Link to={storeRoutes.TRANSLATIONS()}>
						<Button variant="outline" size="sm">
							{t('backToTranslations')}
						</Button>
					</Link>
				</div>
			</Alert>
		</div>
	)
}

